import { all } from 'redux-saga/effects'

import { buyerSagas, walletSagas, campaignPublicSagas, rewardPublicSagas } from 'primsell-shared-layer/features'
import { redeemSaga } from 'features'

function* rootSaga(): Generator {
  yield all([buyerSagas(), walletSagas(), campaignPublicSagas(), redeemSaga(), rewardPublicSagas()])
}

export { rootSaga }
